import { ChangeEvent, useEffect, useReducer } from "react";
import { useManualOccurrence } from "contexts/register/ManualOccurrence";
import OccurrenceManagementService from "services/OccurrenceManagementService";
import Button from "components/Button";
import Input from "components/Input";
import MaskedInput from "components/MaskedInput";
import { INITIAL_VEHICLE_STATE, dataReducer, VehicleTabData } from "./reducers";
import * as S from "./styles";

export default function OccurrenceDataTab() {
  const [data, dispatchData] = useReducer(dataReducer, INITIAL_VEHICLE_STATE);

  const { occurrenceToEdit, refetch } = useManualOccurrence();

  useEffect(() => {
    dispatchData({
      type: "ID",
      payload: occurrenceToEdit.superficialVehicle.id,
    });
  }, []);

  async function handleUpdate() {
    const dataKeyValuesWithoutIdKey = Object.entries(data).filter(
      ([key]) => key !== "id"
    );
    const dataValues = dataKeyValuesWithoutIdKey.map(([_key, value]) => value);
    const hasSomeDataValueChanged = dataValues.some((item) => Boolean(item));

    if (hasSomeDataValueChanged) {
      const vehicleData: Partial<VehicleTabData> = Object.keys(data).reduce(
        (acc, key) => {
          if (data[key as keyof VehicleTabData] !== "")
            return { ...acc, [key]: data[key as keyof VehicleTabData] };

          return acc;
        },
        {}
      );

      await OccurrenceManagementService.updateVehicleData(
        occurrenceToEdit.id,
        vehicleData
      );
    }

    refetch();
  }

  return (
    <S.Wrapper>
      <S.ContentWrapper>
        <Input
          label="Marca"
          id="brand"
          name="brand"
          defaultValue={occurrenceToEdit.superficialVehicle.brand}
          required
          type="text"
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            dispatchData({ type: "BRAND", payload: event.target.value });
          }}
        />
        <Input
          label="Modelo"
          id="model"
          name="model"
          defaultValue={occurrenceToEdit.superficialVehicle.model}
          required
          type="text"
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            dispatchData({ type: "MODEL", payload: event.target.value });
          }}
        />
        <MaskedInput
          mask="aaa-9*99"
          label="Placa"
          id="plate"
          name="plate"
          defaultValue={occurrenceToEdit.superficialVehicle.plate}
          required
          type="text"
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            dispatchData({ type: "PLATE", payload: event.target.value });
          }}
        />
        <Input
          label="Cor"
          id="color"
          name="color"
          required
          defaultValue={occurrenceToEdit.superficialVehicle.color}
          type="text"
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            dispatchData({ type: "COLOR", payload: event.target.value });
          }}
        />
        <Input
          label="Descrição"
          id="description"
          defaultValue={occurrenceToEdit.superficialVehicle.description}
          name="description"
          required
          type="text"
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            dispatchData({ type: "DESCRIPTION", payload: event.target.value });
          }}
        />
      </S.ContentWrapper>
      <S.ButtonWrapper>
        <Button title="Atualizar informações" onClick={handleUpdate} />
      </S.ButtonWrapper>
    </S.Wrapper>
  );
}
